import { useState } from "react";
import { useLang } from "@/contexts/LanguageContext";
import { EVENTS_DATA } from "@/data/products";
import { ArrowUpRight, MapPin } from "lucide-react";

const Eventos = () => {
  const { t, lang } = useLang();
  const [hovered, setHovered] = useState(null);

  return (
    <div data-testid="page-eventos" className="relative">
      {/* Background image follows hover */}
      <div className="fixed inset-0 pointer-events-none z-0">
        {EVENTS_DATA.map((e) => (
          <div
            key={e.id}
            className="absolute inset-0 transition-opacity duration-700"
            style={{ opacity: hovered === e.id ? 0.08 : 0 }}
          >
            <img src={e.image} alt="" className="w-full h-full object-cover" />
          </div>
        ))}
      </div>

      {/* Header */}
      <section className="relative px-6 md:px-12 lg:px-20 pt-16 md:pt-24 pb-16">
        <div className="max-w-[1500px] mx-auto">
          <div className="text-[11px] uppercase tracking-[0.3em] text-caramel mb-6 font-medium">
            {t.events.overline}
          </div>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-light tracking-tighter leading-[0.95] text-ink">
            {t.events.title}
          </h1>
          <p className="mt-8 text-lg md:text-xl text-ink-muted font-light max-w-2xl leading-relaxed">
            {t.events.sub}
          </p>
        </div>
      </section>

      {/* List */}
      <section className="relative px-6 md:px-12 lg:px-20 pb-32">
        <div className="max-w-[1500px] mx-auto border-t border-ink/30">
          {EVENTS_DATA.map((ev) => (
            <div
              key={ev.id}
              data-testid={`event-row-${ev.id}`}
              onMouseEnter={() => setHovered(ev.id)}
              onMouseLeave={() => setHovered(null)}
              className="group grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-14 border-b border-ink/20 items-center cursor-pointer transition-colors hover:bg-bg/50"
            >
              {/* Date */}
              <div className="col-span-3 md:col-span-2">
                <div className="font-serif text-5xl md:text-7xl lg:text-8xl text-ink font-light leading-none">
                  {ev.date.d}
                </div>
                <div className="mt-2 text-[11px] uppercase tracking-[0.3em] text-caramel font-medium">
                  {ev.date.m} · {ev.date.y}
                </div>
              </div>

              {/* Title + location */}
              <div className="col-span-7 md:col-span-7">
                <h3 className="font-serif text-2xl md:text-4xl font-light text-ink tracking-tight leading-tight transition-colors group-hover:text-wine">
                  {ev.name[lang] || ev.name.es}
                </h3>
                <div className="mt-3 flex items-center gap-2 text-xs md:text-sm text-ink-muted uppercase tracking-widest">
                  <MapPin className="w-3.5 h-3.5 text-caramel" strokeWidth={1.5} />
                  {ev.location}
                </div>
                <p className="mt-4 text-sm md:text-base text-ink-muted font-light max-w-xl leading-relaxed hidden md:block">
                  {ev.desc[lang] || ev.desc.es}
                </p>
              </div>

              {/* CTA */}
              <div className="col-span-2 md:col-span-3 text-right">
                <span className="inline-flex items-center gap-2 text-[10px] md:text-xs uppercase tracking-[0.2em] font-medium text-wine">
                  <span className="hidden md:inline">{t.events.viewDetails}</span>
                  <ArrowUpRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:rotate-45" strokeWidth={1.5} />
                </span>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Eventos;
